import { ELVARLI as appId } from "./constants";
import storedCatalog from "./rangeConfig/catalog.json";
import storedTemplates from "./rangeConfig/template.json";
import { RangeApi } from "@inter-ikea-storagetwo/range/dist/rangeApi";
import * as stability from "@inter-ikea-storagetwo/range/dist/functions/stability";
import { getCatalogAndTemplate } from "@inter-ikea-storagetwo/range/dist/utils/catalogAndTemplateUtils";
import { components } from "./components";
import { systemsDefinitionList } from "./systems";
import { validations } from "./validations";
import PlannerComponentSerializer from "./PlannerComponentSerializer";
import { Segment } from "@inter-ikea-storagetwo/dexf-utils";
class Elvarli extends RangeApi {
    constructor({ core, env = Segment.production, catalogAndTemplate, }) {
        const { catalog, templates } = getCatalogAndTemplate(catalogAndTemplate, storedCatalog, storedTemplates);
        super({
            core,
            systemsDefinitionList,
            templates,
            catalog,
            env,
            appId,
            components,
            validations,
            componentSerializer: new PlannerComponentSerializer(),
        });
    }
}
export { Elvarli as default, stability };
